goog.provide('el8.ptdata.denialMedOrders');

goog.require('el8.model.base');
goog.require('el8.data.pharmacies');
goog.require('el8.data.medications');
goog.require('el8.ptdata.model.med.medOrder');
goog.require('el8.util.ss');


el8.ptdata.denialMedOrders = (function() {

    var _class = function(spec) {
        this.populate(spec);
        if (spec.pharmacy) {
            el8.data.pharmacies.create(spec.pharmacy);
        }
        if (spec.medication) {
            this.setMedication(el8.data.medications.create(spec.medication));
        }
        if (spec.original_med_order) {
            this.setOriginalMedOrder(el8.ptdata.model.med.medOrder(spec.original_med_order));
        }
    };
    
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.addStringProperty('pharmacyNcpdpid');

    _class.addProperty('medication');
    _class.addProperty('originalMedOrder');
    
    _class.addIntProperty('requestedRefills');
    _class.addStringProperty('denialReason');
    _class.addStringProperty('denialNote');
    _class.addStringProperty('state');

    _class.addIntProperty('supervisingPhysicianId');

    _class.prototype.getPharmacy = function() {
        if (this.getPharmacyNcpdpid()) {
            return el8.data.pharmacies.getByKey(this.getPharmacyNcpdpid());
        }
        return null;
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        var pharmacy = this.getPharmacy();
        var signUserName = this.getSignUserName();
        var signUserBehalfName = this.getSignUserBehalfName();
        var supervisingPhysicianName = this.getSupervisingPhysicianName();

        /* keeping these keys to preserve compatibility with existing template */
        $.extend(mapped, {
            medication: this.getMedication().getDisplayName(),
            refills: this.getRequestedRefills(),
            reason: this.getDenialReason(),
            note: this.getDenialNote(),
            pharmacy: pharmacy ? pharmacy.asSoyMap() : null,
            signUserName: signUserName,
            signUserBehalfName: signUserBehalfName,
            supervisingPhysicianName: supervisingPhysicianName
        });

        return mapped;
    };

    _class.prototype.getSupervisingPhysicianName = function() {
        if (!this.getSupervisingPhysicianId()) { return; }
        var physician = el8.data.referencedPracticians.getById(this.getSupervisingPhysicianId());
        return (physician) ? physician.getFullName() : '';
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        deleteFn: function(var_args) { return el8.ptdata.documentDeleteFn.apply(that, arguments); }
    });

    /**
     * Polling for ePrescribing results
     */

    var POLL_INTERVAL = 3000; // every 3 seconds
    var POLL_MAX_ATTEMPTS = 10; // for 30 seconds

    var Poll = function(items) {
        var that = this;
        this.intervalId = null;
        this.attempts = 0;
        this.itemIds = items.map(function(a) { return a.getId(); });
        this.pollFn = function() {
            that.attempts++;
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('getDenialMedOrderStatuses'),
                data: {'denial_med_order_id': that.itemIds},
                success: function(data) {
                    var stopPoll = true;
                    for(var i=0; i<that.itemIds.length; i++) {
                        var item = el8.ptdata.denialMedOrders.getById(that.itemIds[i]);
                        var info = data[that.itemIds[i]];

                        var currState = item.getState();
                        if (currState !== info['state']) {
                            item.setState(info['state']);
                            el8.ptdata.denialMedOrders.itemNotify(item);
                            // TODO In future, denial med orders should show in req act
                            //  and we'll need a notify() here
                        }
                        // If eRx is still pending, then don't stop polling
                        if (el8.util.ss.isPending(item.getState())) {
                            stopPoll = false;
                        }
                    }
                    if (stopPoll || (that.attempts === POLL_MAX_ATTEMPTS)) {
                        that.endPoll();
                    }
                },
                error: function() {
                    that.endPoll();
                }
            });
        };
        this.startPoll = function() {
            var that = this;
            that.intervalId = $.el8_setInterval(function() { that.pollFn(); }, POLL_INTERVAL);
        };
        this.endPoll = function() {
            var that = this;
            $.el8_clearInterval(that.intervalId);
        };
        return this;
    };

    that.addERxPoller = function(items) {
        var poll = new Poll(items);
        poll.startPoll();
    };

    return that;

})();
